// extracted by mini-css-extract-plugin
export default {"wrapper":"TopBar_wrapper__VLdtC","topBarHidden":"TopBar_topBarHidden__6nYmz","livesBlock":"TopBar_livesBlock__drFZF","scoreBlock":"TopBar_scoreBlock__R+v30"};